import { useEffect, useRef, useCallback } from "react";
import Lenis from "lenis";
import "@/App.css";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Intro from "@/components/site/Intro";
import Story from "@/components/site/Story";
import Work from "@/components/site/Work";
import Writing from "@/components/site/Writing";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import { Toaster } from "@/components/ui/sonner";

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const onNavigate = useCallback((hash) => {
    const lenis = lenisRef.current;
    if (!hash) {
      lenis ? lenis.scrollTo(0) : window.scrollTo(0, 0);
      return;
    }
    const el = document.querySelector(hash);
    if (!el) return;
    lenis ? lenis.scrollTo(el, { offset: -20 }) : el.scrollIntoView({ behavior: "smooth" });
  }, []);

  return (
    <div className="App">
      <Hero onNavigate={onNavigate} />
      <Marquee />
      <Intro onNavigate={onNavigate} />
      <Story />
      <Work />
      <Writing />
      <Contact />
      <Footer />
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
